import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import OnDOMReady from "shared/util/OnDOMReady";
import addToGlobalStore from "shared/redux/addToGlobalStore";
import addToGlobalAnalyticsMiddleware from "shared/redux/addToGlobalAnalyticsMiddleware";

import payment, { open, close, openEditor } from "ducks/payment";
import paymentAnalytics from "analytics/payment";

import Payment from "apps/payment";

const rootElementId = "payment_modal";

const appendRootElement = () => {
	const previousModal = document.getElementById(rootElementId);

	if (previousModal) {
		previousModal.remove();
	}

	const rootElement = window.document.createElement("div");
	rootElement.id = rootElementId;

	window.document.body.appendChild(rootElement);

	return rootElement;
};

const store = addToGlobalStore({ payment });

addToGlobalAnalyticsMiddleware({
	payment: paymentAnalytics,
});

const ReactPay = {
	init() {
		render(
			(
				<Provider store={store}>
					<Payment />
				</Provider>
			),
			appendRootElement(),
		);
	},

	open(product) {
		store.dispatch(open(product));
	},

	openEditor() {
		store.dispatch(openEditor());
	},

	close() {
		store.dispatch(close());
	},
};

OnDOMReady(() => ReactPay.init());

window.ReactPay = ReactPay;

export default ReactPay;



// WEBPACK FOOTER //
// ./src/features/payment/index.js